import NewBackImg from '../../assets/newBack.png';

const bgImage = new Image();
bgImage.src = NewBackImg;

export class BackgroundScroller {
  private canvasWidth:  number;
  private canvasHeight: number;
  private scrollSpeed:  number  = 2;
  private currentSpeed: number  = 2;
  private paused:       boolean = false;
  private offsetY:      number  = 0;

  private _scrollTotal: number = 0;

  constructor(canvasWidth: number, canvasHeight: number) {
    this.canvasWidth  = canvasWidth;
    this.canvasHeight = canvasHeight;
  }

  update(dt = 16.667) {
    const targetSpeed = this.paused ? 0 : this.scrollSpeed;

    const alpha = 1 - Math.pow(1 - 0.05, dt / 16.667);
    this.currentSpeed += (targetSpeed - this.currentSpeed) * alpha;
    if (Math.abs(this.currentSpeed) < 0.01) this.currentSpeed = 0;
    const framesThisDt = dt / 16.667;
    if (!this.paused) {
      this._scrollTotal += targetSpeed * framesThisDt;
    }

    // Match world travel at every refresh rate, including pause/resume.
    if (!this.paused) this.offsetY -= targetSpeed * framesThisDt;

    if (bgImage.complete && bgImage.naturalHeight > 0) {
      const tileH  = bgImage.naturalHeight * (this.canvasWidth / bgImage.naturalWidth);
      this.offsetY = ((this.offsetY % tileH) + tileH) % tileH;
    }
  }

  draw(ctx: CanvasRenderingContext2D) {
    if (!bgImage.complete || bgImage.naturalWidth === 0) {
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);
      return;
    }

    const scale  = this.canvasWidth / bgImage.naturalWidth;
    const tileH  = bgImage.naturalHeight * scale;
    const off    = ((this.offsetY % tileH) + tileH) % tileH;
    const startY = off - tileH;

    for (let y = startY; y < this.canvasHeight; y += tileH) {
      ctx.drawImage(bgImage, 0, Math.round(y), this.canvasWidth, Math.ceil(tileH) + 1);
    }
  }
  getScrollTotal(): number  { return this._scrollTotal; }
  setScrollTotal(v: number) { this._scrollTotal = v; }
  resetScrollTotal()        { this._scrollTotal = 0; }
  setSpeed(speed: number)   { this.scrollSpeed = speed; }
  setSpeedImmediate(speed: number) {
    this.scrollSpeed = speed;
    this.currentSpeed = speed;
  }
  getSpeed(): number        { return this.scrollSpeed; }
  getCurrentSpeed(): number { return this.currentSpeed; }
  pause()                   { this.paused = true; }
  resume()                  { this.paused = false; }

  resize(canvasWidth: number, canvasHeight: number) {
    this.canvasWidth  = canvasWidth;
    this.canvasHeight = canvasHeight;
  }
}
